// @owners { team: patient-health }
import { Column, Row } from '@alto/design-system';
// eslint-disable-next-line @alto/no-pocky-import
import { Label, Text, palette } from '@alto/pocky';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import styledNative from 'styled-components/native';

type Props = {
  children?: React.ReactNode;
  icon: IconProp;
  label?: string;
  onClick?: () => void;
};

const MedListDetailMedAttrContainer = styledNative(Row)`
  &:not(:last-child) {
    margin-bottom: 1.25rem;
  }
`;

export const AttrIcon = styled(FontAwesomeIcon)`
  margin-right: 0.75rem;
`;

const AttrContainer = styled.div`
  margin-left: 1.625rem;
`;

const ClickableText = styled(Text)<{ onClick: () => void }>`
  cursor: pointer;
`;

export default class MedListDetailMedAttr extends React.PureComponent<Props> {
  static propTypes = {
    children: PropTypes.node,
    icon: PropTypes.node.isRequired,
    label: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    label: undefined,
    onClick: undefined,
  };

  render() {
    const { children, icon, label, onClick } = this.props;

    return (
      <MedListDetailMedAttrContainer>
        <Column>
          <Row>
            <Column>
              <AttrIcon
                icon={icon}
                color={onClick ? palette.royalBlue : palette.grey1}
                size="sm"
              />

              {onClick ? (
                <ClickableText
                  active
                  inline
                  onClick={onClick}
                >
                  {label}
                </ClickableText>
              ) : (
                <Label light>{label}</Label>
              )}
            </Column>
          </Row>

          {React.Children.count(children) > 0 ? (
            <Row>
              <Column>
                <AttrContainer>{children}</AttrContainer>
              </Column>
            </Row>
          ) : null}
        </Column>
      </MedListDetailMedAttrContainer>
    );
  }
}
